var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteUserWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.55514L13.125 18.1101M8.875 18.1101L8.5 9.55514M3.5 4.6661L4.59998 20.7141C4.64831 21.3393 4.93193 21.9229 5.39368 22.3471C5.85542 22.7714 6.46097 23.0047 7.08801 23.0001H14.913C15.54 23.0047 16.1456 22.7714 16.6073 22.3471C17.069 21.9229 17.3527 21.3393 17.401 20.7141L18.501 4.6661M3.5 4.6661H7.25098M3.5 4.6661H1M18.501 4.6661H21M18.501 4.6661H14.75M7.25098 4.6661L7.25 3.44405C7.25949 2.7891 7.52771 2.16452 7.99609 1.70663C8.46448 1.24873 9.095 0.994732 9.75 1.00008H12.25C12.905 0.994732 13.5355 1.24873 14.0039 1.70663C14.4723 2.16452 14.7405 2.7891 14.75 3.44405V4.6661M7.25098 4.6661H14.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUserWhite);
export default __webpack_public_path__ + "static/media/deleteUserWhite.2e51263ff68c1acb2b9aed9e4b90ac05.svg";
export { ForwardRef as ReactComponent };